import { ITEM_KINDS, STATES } from '../../../constants';

const PAGE_TITLE = 'Insurance Quotes';

export function InsuranceQuotesConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_INSURANCE_QUOTES, {
    url: '/insurance-quotes',
    params: {
      toast: null,
    },
    views: {
      '@': {
        template: `<upd-insurance-quotes></upd-insurance-quotes>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    titleBar: {
      title: PAGE_TITLE,
      icon: 'security-no-lock',
    },
    analytics: {
      page: 'Insurance Acquisition',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.INSURANCE_QUOTE,
        singleton: true,
      },
    },
  });
}
